export const apiPaths = {
  fedcm: {
    config: '/fedcm/config',
  },
};
